export default __webpack_public_path__ + "static/media/canvas-icon.e8d557a4.svg";